module.exports = __webpack_public_path__ + "static/media/notes1.2332bea1.png";